import { render, staticRenderFns } from "./boletoRem.vue?vue&type=template&id=3d662527&"
import script from "./boletoRem.vue?vue&type=script&lang=js&"
export * from "./boletoRem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports